export default function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/is-function.js